module.exports = __webpack_public_path__ + "img/prize.0a5f6883.png";